/* eslint-disable no-unused-vars */
import { ArrowRight } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import "../../assets/css/aunjai-formsuccess.css";
import PrimaryButton from "../../components/ui/PrimaryButton";
import OutlinedButton from "../../components/ui/OutlinedButton";
import { useTranslation } from "react-i18next";
import { CONTACT } from "../../constants/contact";

const FillFormStep4 = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation('form3');
  const gotoProfile = () => {
    navigate("/profile");
  };

  const handlePhoneClick = () => {
    window.location.href = CONTACT.PHONE_TEL;
  };

  const handleLineClick = () => {
    window.open(CONTACT.LINE_URL, "_blank");
  };

  function gotoMyLoan() {
    navigate(`/my-loans`);
  }

  return (
    <div id="pageSuccess">
      <div className="wrapContent">
        <div id="pSuccess">
          <div className="bFillForm">
            <div className="bContent">
              <div className="bNoti">
                <div className="bImg">
                  <img
                    src="/assets/img/ci/icon/ico-email.svg"
                    alt="Email Icon"
                  ></img>
                </div>
                <div className="bText">
                  <h3>{t('success1')}</h3>
                  <p>
                    {t('success2')}
                  </p>
                </div>
              </div>
              <div className="bContact">
                <div className="bText">
                  <p>{t('success3')} </p>
                </div>
                <div className="bPhone">
                  <p onClick={handlePhoneClick}>
                    {t('success4')} <span>{CONTACT.PHONE_DISPLAY}</span>
                  </p>
                  <div></div>
                </div>
                <div className="bLine">
                  <p onClick={handleLineClick}>
                    LINE <span>{CONTACT.LINE_ID}</span>
                  </p>
                  <ArrowRight size={16} />
                </div>
                <div className="bLine">
                  <p onClick={() => window.open(CONTACT.FACEBOOK_URL, "_blank")}>
                    Facebook <span>{CONTACT.FACEBOOK}</span>
                  </p>
                  <ArrowRight size={16} />
                </div>
                <div className="bTime">
                  <p onClick={() => window.open(CONTACT.WEBSITE_URL, "_blank")}>
                    {t('success8')} <span>{CONTACT.WEBSITE}</span>
                  </p>
                  <ArrowRight size={16} />
                </div>
              </div>
            </div>

            <footer className="footer">
              <div className="bBtn bActionButton">
                <OutlinedButton onClick={gotoProfile}>
                  {t('success10')}
                </OutlinedButton>
                <PrimaryButton onClick={gotoMyLoan}>{t('success11')}</PrimaryButton>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FillFormStep4;
